export default __webpack_public_path__ + "static/media/checkbox_checked.b66164c5.svg";